import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import nb from './locales/nb.json'

export const i18n = createI18n({
  legacy: false,           // Composition API mode — use useI18n() in <script setup>
  globalInjection: true,   // Makes $t() available in all templates without importing useI18n
  locale: 'nb',            // Default locale; overridden at boot from tenant settings
  fallbackLocale: 'en',
  messages: { en, nb },
})
